export default
{
    computed:
    {
        scope()
        {
            return (
            {
                file:
                {
                    attributes:
                    {
                        class:
                        {
                            'File-drag-enter' : this.dragEnter,
                            'File-uploading'  : this.isUploading,
                        }
                    },

                    input:
                    {
                        attributes:
                        {
                            'ref'      : 'upload',
                            'type'     : 'file',
                            'accept'   : this.accept,
                            'multiple' : this.multiple
                        },

                        listeners:
                        {
                            change: ( event ) =>
                            {
                                this.upload( event.target );

                                this.$refs.upload.value = null;
                            }
                        }
                    }
                }
            })
        },

        /*
        value:
        {
            get()
            {
                return this.modelValue;
            },
            set()
            {
                this.$emit( 'update:modelValue', this.uploadedFiles.map( file => { return { id: file.id, name: file.name, type: file.type, size: file.size } } ) )
            }
        }
        */
    }
}